<template>
  <div class="fee_container">
    <div class="title">
      <h3>{{ title }}</h3>
    </div>
    <div class="top_noti">
      <p>{{ tradeFee.title }}</p>
      <p class="fs12">{{ tradeFee.description }}</p>
      <div class="circle_info">
        <div class="circle_info-wrap">
          <div class="maker">
            <div>
              <p class="fs14">{{ tradeFee.maker.title }}</p>
              <p>{{ tradeFee.maker.fee }}</p>
            </div>
          </div>
          <div class="taker">
            <div>
              <p class="fs14">{{ tradeFee.taker.title }}</p>
              <p>{{ tradeFee.taker.fee }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contents">
      <div class="calc_info">
        <p class="title">
          {{ feeInformation.calcInfo.title }}
        </p>
        <p class="desc">
          {{ feeInformation.calcInfo.description }}
        </p>
      </div>
      <div class="calc_info">
        <div class="title">
          {{ feeInformation.tradeInfo.title }}
        </div>
        <div class="desc buying">
          <span class="label">{{
            feeInformation.tradeInfo.type[0].title
          }}</span>
          {{ feeInformation.tradeInfo.type[0].description }}
        </div>
        <div class="desc sell">
          <span class="label">{{
            feeInformation.tradeInfo.type[1].title
          }}</span>
          {{ feeInformation.tradeInfo.type[1].description }}
        </div>
      </div>
      <div class="fee_info">
        <div class="title">
          {{ depositWithdraw.title }}
        </div>
        <div class="desc">
          <p>
            {{ depositWithdraw.description[0] }}
          </p>
          <p>
            {{ depositWithdraw.description[1] }}
          </p>
          <div class="desc mt10">
            <p>{{ depositWithdraw.depositCalc.title }}</p>
            <p>{{ depositWithdraw.depositCalc.description }}</p>
          </div>
        </div>
      </div>
      <div class="fee-table">
        <div class="fee-table-header">
          <div
            v-for="(header, index) in depositWithdraw.feeTable.header"
            :key="index"
            class="fee-table-header-item"
          >
            {{ header }}
          </div>
        </div>
        <div class="fee-table-body">
          <div
            v-for="(body, index) in depositWithdraw.feeTable.body"
            :key="index"
            class="fee-table-body-row"
          >
            <div class="fee-table-body-item">
              {{ body.code }}
            </div>
            <div class="fee-table-body-item">
              {{ body.minOut }}
            </div>
            <div class="fee-table-body-item">
              {{ body.inFee }}
            </div>
            <div class="fee-table-body-item">
              {{ body.outFee }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.depositWithdraw.feeTable.body = this.feeInformationCoin;
  },
  data() {
    return {
      title: "수수료 안내",
      tradeFee: {
        title: "거래 수수료",
        description: "* 원화(KRW)마켓 기준",
        maker: {
          title: "Maker",
          fee: "0.1%",
        },
        taker: {
          title: "Taker",
          fee: "0.1%",
        },
      },
      feeInformation: {
        calcInfo: {
          title: "거래수수료 계산방식",
          description: "체결금액(주문수량 × 주문가격) × 수수료율(%)",
        },
        tradeInfo: {
          title: "거래수수료 정산방식",
          type: [
            {
              title: "매수",
              description:
                "주문 예시) 1 BTC를 10,000,000원에 매수 (거래수수료 0.1%) = 내 계정에 1 BTC 반영, 10,010,000원 차감",
              type: "maker",
            },
            {
              title: "매도",
              description:
                "주문 예시) 1 BTC를 10,000,000원에 매도(거래수수료 0.1%) = 내 계정에 9,990,000원 반영, 1 BTC 차감",
              type: "taker",
            },
          ],
        },
      },
      depositWithdraw: {
        title: "입출금 수수료",
        description: [
          "플라이빗 내부 출금 시 수수료가 발생하지 않습니다.",
          "출금수수료는 네트워크 상황에 따라 상시 변동됩니다.",
        ],
        depositCalc: {
          title: "출금수수료 정산방식:",
          description:
            "예시) 10,000 KRW 출금 시 출금수수료 1,000 KRW를 포함하여 총 11,000 KRW 출금",
        },
        feeTable: {
          header: ["가상자산명", "최소 출금액", "입금 수수료", "출금 수수료"],
          body: [],
        },
      },
    };
  },
  computed: {
    ...mapGetters(["feeInformationCoin"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.fee_container {
  padding: 30px 20px;
  color: #333d48;
  .title {
    text-align: center;
  }
  .top_noti {
    width: 100%;
    /* max-width: 260px; */
    margin: 20px auto;
    padding: 20px 10px;
    text-align: center;
    border: 1px solid #dcdfe3;
    border-radius: 20px;
    .circle_info {
      margin-top: 20px;
      &-wrap {
        position: relative;
        display: flex;
        width: 100%;
        max-width: 270px;
        height: 130px;
        margin: 0 auto;
      }
      .maker,
      .taker {
        position: absolute;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 130px;
        background-image: url("@/assets/img/feeinfo/bg_maker_fee.svg");
        background-repeat: no-repeat;
        background-size: 130px 130px;
        p {
          color: #fff;
        }
      }
      .maker {
        left: 0;
        background-image: url("@/assets/img/feeinfo/bg_maker_fee.svg");
      }
      .taker {
        right: 0;
        background-image: url("@/assets/img/feeinfo/bg_taker_fee.svg");
      }
    }
  }
  .contents {
    text-align: left;
    .calc_info {
      .title {
        margin-top: 20px;
        text-align: left;
      }
      .desc {
        font-size: 12px;
        &.buying {
          color: #eb3246;
          /* .label {
            padding: 2px 5px;
            color: #fff;
            background-color: #eb3246;
          } */
        }
        &.sell {
          color: #1655a7;
          /* .label {
            padding: 2px 5px;
            color: #fff;
            background-color: #1655a7;
          } */
        }
      }
    }
    .fee_info {
      .title {
        margin-top: 20px;
        text-align: left;
      }
      .desc {
        font-size: 12px;
      }
    }
    .fee-table {
      margin-top: 40px;
      border-top: 2px solid #222;
      border-bottom: 1px solid #dcdfe3;

      &-header {
        display: flex;
        align-items: center;
        background: #f3f5f7;

        &-item {
          flex-basis: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 50px;
          font-size: 12px;
          font-weight: 500;
          color: #222;
          text-align: center;
          border-right: 1px solid #dcdfe3;

          &:last-child {
            border-right: 0;
          }
        }
      }

      &-body {
        display: flex;
        flex-direction: column;

        &-row {
          display: flex;
          align-items: center;
          border-top: 1px solid #dcdfe3;
          background: #fff;

          &:hover {
            background: darken(#fff, $amount: 0.6);
          }
        }

        &-item {
          flex-basis: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 50px;
          font-size: 12px;
          font-weight: 300;
          color: #222;
          text-align: center;
          border-right: 1px solid #dcdfe3;

          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
}
</style>
